<ng-container *ngIf="!(isOnHostRoute$ | async)">
    <router-outlet></router-outlet>
</ng-container>

<ng-container *ngIf="!(canBypassHealthCheck$ | async) && isWaitingForHealthAndUser">
    <div class="justify-content-center">
        <lsq-circle-loader></lsq-circle-loader>
    </div>
</ng-container>
<ng-container
    *ngIf="!(canBypassHealthCheck$ | async) && !isWaitingForHealthAndUser && !isApiHealthy"
>
    <div [ngClass]="[containerClass || '', topContentAnnouncementClass || '']">
        <lsq-navigation [hideNavigation]="true"> </lsq-navigation>
        <div class="wrapper stick-to-top top-content-height">
            <lsq-unavailable></lsq-unavailable>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isOnHostRoute$ | async">
    <ng-container
        *ngIf="(canBypassHealthCheck$ | async) || (!isWaitingForHealthAndUser && isApiHealthy)"
    >
        <div [ngClass]="[containerClass || '', topContentAnnouncementClass || '']">
            <lsq-navigation
                [settingsDropdownNavigationItems]="navigationState.settingsDropdownNavigationItems"
                (openMobile)="openMobileNav()"
            >
                <ng-template #settingsDropdownAppend let-eventEmitter="eventEmitter">
                    <li
                        *ngIf="isLoggedIn$ | async"
                        class="dropdown-navigation-item-appended lsq-dropdown-item lsq-dropdown-navigation-item"
                        [style.margin-top]="'1rem'"
                    >
                        <a
                            [routerLink]="logoutNavigationItem.routerLink"
                            [queryParams]="logoutNavigationItem.queryParams"
                            [style.margin-top]="'1rem'"
                            (click)="eventEmitter.emit($event)"
                        >
                            <span i18n="Log out menu item">Log out of LSQ</span>
                        </a>
                    </li>
                </ng-template>
            </lsq-navigation>

            <div
                class="wrapper stick-to-top top-content-height"
                aria-live="polite"
                [ngClass]="{
                    'has-footer': true
                }"
            >
                <router-outlet></router-outlet>
                <lsq-footer></lsq-footer>
            </div>
        </div>

        <lsq-modal></lsq-modal>
        <lsq-backdrop></lsq-backdrop>
        <ng-template #mobileNavTemplate>
            <lsq-mobile-navigation [navigationItems]="navigationState.allNavigationItems">
            </lsq-mobile-navigation>
        </ng-template>
        <lsq-action-sheet></lsq-action-sheet>
    </ng-container>
</ng-container>
